/* =============================================
   STICKY HEADER JAVASCRIPT - v2 (13 Sept 2026)
   Fix: near the top of the page the header scrolls with the page, so it never
   covers the product title; the announcement bar height is read live (its
   slides differ in height). Below the header area: hide on scroll down, show on scroll up.
   ============================================= */

(function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initStickyHeader, 100);
    });

    function initStickyHeader() {
        const header = document.querySelector('.header-classic') || document.querySelector('.header');
        if (!header) return;

        const announcementBar = document.querySelector('.announcement-bar');
        const annHeight = function() { return announcementBar ? announcementBar.offsetHeight : 0; };

        const headerHeight = header.offsetHeight;
        let lastScrollY = window.scrollY;
        let isHidden = false;

        // Placeholder keeps the page content below the fixed header
        const placeholder = document.createElement('div');
        placeholder.className = 'header-sticky-placeholder';
        placeholder.style.cssText = 'height: ' + headerHeight + 'px; display: block;';
        header.parentNode.insertBefore(placeholder, header.nextSibling);

        header.style.cssText += `
            position: fixed !important;
            top: ${annHeight()}px;
            left: 0 !important;
            right: 0 !important;
            width: 100% !important;
            z-index: 999 !important;
            transition: transform 0.3s ease, box-shadow 0.3s ease !important;
            background: #fff !important;
        `;

        function onScroll() {
            const y = window.scrollY;
            const ann = annHeight();
            const threshold = ann + headerHeight;

            if (y < threshold) {
                // Header area still on screen: move with the page, never overlap content
                header.style.top = (ann - y) + 'px';
                header.style.transform = 'translateY(0)';
                header.style.boxShadow = 'none';
                isHidden = false;
            } else {
                header.style.top = '0px';
                header.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
                if (y > lastScrollY) {
                    if (!isHidden) { header.style.transform = 'translateY(-100%)'; isHidden = true; }
                } else if (y < lastScrollY) {
                    if (isHidden) { header.style.transform = 'translateY(0)'; isHidden = false; }
                }
            }
            lastScrollY = y;
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        if (announcementBar && 'ResizeObserver' in window) {
            new ResizeObserver(onScroll).observe(announcementBar);
        }
        onScroll();
    }
})();
